@if (product.lastPurchased) {
  <i
    class="aimo-icon icon-sm icon-clock-counter-clockwise icon-inline icon-dark-grey"
    triggers="mouseenter:mouseleave click"
    placement="bottom"
    container="body"
    [ngbPopover]="
        getLastPurchasedTranslationKey(product)
            | cxTranslate
                : {
                      date: (convertDate(product.lastPurchased) | cxDate: ('aimo.dateFormat' | cxTranslate)),
                  }
    "></i>
}
